import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonGroup from '@jetbrains/ring-ui/components/button-group/button-group'
import {Size} from '@jetbrains/ring-ui/components/input/input'
import type {ChangeEvent} from 'react'
import {useCallback} from 'react'

import type {VersionedSettingsDto} from '../../services/pipelinesApi.types'
import Input from '../Input'

import styles from './ConfigurationStorageSwitch.css'

const DEFAULT_FILENAME = '.teamcity.yml'

type Props = {
  storedInRepo?: boolean
  className?: string
  changeStorageHandler: (settings: VersionedSettingsDto) => void
}

function ConfigurationStorageSwitch({
  storedInRepo = false,
  className,
  changeStorageHandler,
}: Props) {
  const handleFilenameChange = useCallback(
    ({currentTarget: {value}}: ChangeEvent<HTMLInputElement>) => {
      changeStorageHandler({filename: value})
    },
    [changeStorageHandler],
  )

  return (
    <div className={className}>
      <div className={styles.label}>{'Store the configuration YAML file:'}</div>
      <ButtonGroup className={styles.toggle}>
        <Button
          className={styles.item}
          active={storedInRepo}
          onClick={() => {
            changeStorageHandler({storedInRepo: true})
          }}
        >
          {'in VCS repository'}
        </Button>
        <Button
          className={styles.item}
          active={!storedInRepo}
          onClick={() => changeStorageHandler({storedInRepo: false})}
        >
          {'on TeamCity server'}
        </Button>
      </ButtonGroup>
      {storedInRepo && (
        <Input
          disabled
          size={Size.FULL}
          className={styles.input}
          label={'YAML file name and path'}
          value={DEFAULT_FILENAME}
          onChange={handleFilenameChange}
        />
      )}
    </div>
  )
}

export default ConfigurationStorageSwitch
